<template>
  <v-flex
    id="packsAmount"
    class="question"
  >
    <h2 class="header">
      {{ $t('gift_giving_report.menu.part_1.2') }}
    </h2>
    <ul class="questions-list">
      <li v-if="giftGivingReportQuestions.hasOwnProperty('package_count')">
        <p
          class="custom mb-1"
          :class="{ required: giftGivingReportQuestions.package_count.required }"
        >
          {{ giftGivingReportQuestions.package_count.label }}
        </p>
        <v-layout>
          <v-flex md4>
            <v-text-field
              v-model="packsAmount"
              v-validate="{ ...packsAmountRules(giftGivingReportQuestions.package_count.required) }"
              :placeholder="$t('label.amount')"
              :error-messages="errors.collect('packsAmount')"
              :data-vv-as="' '"
              data-vv-name="packsAmount"
              :required="giftGivingReportQuestions.package_count.required"
              :disabled="readOnly"
              inputmode="numeric"
            />
          </v-flex>
        </v-layout>
      </li>
    </ul>
    <v-divider class="my-4" />
  </v-flex>
</template>

<script>
import { createHelpers } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
import sheetValidationRules from '@/mixins/sheet/sheetValidationRules';

const { mapFields } = createHelpers({
    getterType: 'giftGivingReport/getGiftGivingReportState',
    mutationType: 'giftGivingReport/updateGiftGivingReportState'
});

export default {
    name: 'PacksAmount',
    mixins: [sheetValidationRules],
    inject: ['$validator'],
    props: {
        readOnly: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapFields(['packsAmount']),
        ...mapGetters('giftGivingReport', ['giftGivingReportQuestions'])
    }
};
</script>

<style scoped></style>
